import { useMemo } from 'react';
import { useAppSelector } from './useAuth';
import { getHubId, getRoleHubRelations } from '../utils/cookieUtils';
import { ROLES } from './useRBAC';

interface HubOption {
  hubmasterid: number;
  hubname: string;
}

const useRoleBasedHubFiltering = () => {
  const { user } = useAppSelector((state) => state.auth);
  const userHubId = getHubId();
  const relations = getRoleHubRelations();
  const isSuperAdmin = user?.roleid === ROLES.SUPER_ADMIN;

  const allowedHubIds = useMemo(() => {
    if (relations && relations.length > 0) return Array.from(new Set(relations.map((r) => r.hubid)));
    return userHubId !== null ? [userHubId] : [];
  }, [relations, userHubId]);

  const isMultiHub = Boolean(relations && relations.length > 1);

  const filterHubOptions = useMemo(() => (hubOptions: HubOption[]) => {
    if (isSuperAdmin) return hubOptions;
    if (allowedHubIds.length === 0) return [];
    return hubOptions.filter((hub) => allowedHubIds.includes(hub.hubmasterid));
  }, [isSuperAdmin, allowedHubIds]);

  return { filterHubOptions, isSuperAdmin, isMultiHub, allowedHubIds };
};

export default useRoleBasedHubFiltering;
